export class ImageCompareViewer {
    constructor() {
        this.selector = "[data-image-compare]";
    }

    init() {
        if (typeof window === "undefined") return;
        const ImageCompare = window.ImageCompare;
        if (typeof ImageCompare !== "function") return;

        const els = document.querySelectorAll(this.selector);
        if (!els || els.length === 0) return;

        els.forEach((el) => {
            if (el.dataset.imageCompareMounted === "1") return;
            try {
                new ImageCompare(el, {
                    controlColor: "#FFFFFF",
                    controlShadow: true,
                    addCircle: true,
                    addCircleBlur: true,
                    smoothing: true,
                    smoothingAmount: 120,
                    startingPoint: 50,
                }).mount();
                el.dataset.imageCompareMounted = "1";
            } catch (e) {
                // fail silently; don't break other page scripts
            }
        });
    }
}

